<script lang="ts">
  import { SNAP_DEFINITIONS } from '$lib/core/snap';
  import type { EditorState } from '../editor-state.svelte';

  const { editor }: { editor: EditorState } = $props();
</script>

<!-- Shown only while a tool picks points, the only time snapping applies. -->
{#if editor.placingPoint}
  <div class="bar" role="toolbar" aria-label="Snap">
    {#each SNAP_DEFINITIONS as { kind, label, shortcut } (kind)}
      <button
        type="button"
        aria-pressed={editor.snapSettings.kind === kind}
        title="Snap to {label.toLowerCase()} ({shortcut}); again to turn snapping off"
        onclick={() => editor.chooseSnap(kind)}
      >
        {label}
        <kbd>{shortcut}</kbd>
      </button>
    {/each}
    <span class="divider" aria-hidden="true"></span>
    <button
      type="button"
      aria-pressed={editor.snapSettings.ortho}
      title="Lock to {editor.snapSettings.angleStep}° steps from the last point"
      onclick={() => editor.setOrtho(!editor.snapSettings.ortho)}
    >
      Ortho
      <kbd>{editor.keyLabel({ kind: 'toggleOrtho' })}</kbd>
    </button>
  </div>
{/if}

<style>
  /* An overlay, so showing it never resizes the canvas under the pointer. */
  .bar {
    position: absolute;
    left: 50%;
    bottom: var(--space-3);
    transform: translateX(-50%);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 2px;
    width: max-content;
    max-width: calc(100% - 2 * var(--space-3));
    padding: 3px;
    border: 1px solid var(--color-border);
    border-radius: var(--radius);
    background: color-mix(in srgb, var(--color-surface) 92%, transparent);
    box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 7px;
    border: 1px solid transparent;
    border-radius: 6px;
    background: none;
    color: var(--color-text-muted);
    font: inherit;
    font-size: 0.75rem;
    white-space: nowrap;
    cursor: pointer;
  }

  button:hover {
    border-color: var(--color-border);
  }

  kbd {
    font: inherit;
    font-weight: 600;
    color: var(--color-text);
  }

  button[aria-pressed='true'],
  button[aria-pressed='true'] kbd {
    background: var(--color-accent);
    color: #fff;
  }

  .divider {
    width: 1px;
    align-self: stretch;
    margin: 2px 3px;
    background: var(--color-border);
  }
</style>
